import React from 'react';

export const NumberCircle = ({ number }: { number: number }) => (
	<div
		style={{
			width: 36,
			height: 36,
			minWidth: 36,
			minHeight: 36,
			backgroundColor: '#9e7cff',
			color: 'white',
			borderRadius: '50%',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			fontSize: 26,
			fontWeight: 'bold',
			flexShrink: 0,
		}}
	>
		{number}
	</div>
);
